import ApiService from '../../../services/apiService';
import { mapState } from 'vuex';
import formMixin from '../formMixin';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import set from 'lodash/set';
import 'mapbox-gl/dist/mapbox-gl.css';
export default {
  name: 'NiotaClassicGwMgmtForm',
  mixins: [formMixin],
  props: {
    accounts: {
      type: Array,
      required: false,
      default: () => []
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      initAddrObject: {
        address: null,
        coordinates: [null, null]
      },
      addressObject: {
        address: null,
        coordinates: [null, null]
      },
      originatorDialog: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    isSuperSystemAdmin() {
      return this.permissions['super.system.manage'];
    },
    formCardButtons() {
      if (this.isIotHubManager) {
        return [{
          icon: 'fas fa-save',
          title: this.formItem.id ? this.$i18n_t('Common.save') : this.$i18n_t('Common.saveAndCreate'),
          type: this.isIotHubManager ? 'submit' : 'button',
          valid: this.isIotHubManager ? undefined : false
        }, {
          icon: 'fal fa-times',
          color: 'danger',
          action: 'close',
          tooltip: this.$i18n_t('Common.cancel')
        }];
      }
      return [{
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    },
    coordinateLookup() {
      return get(this.formItem, 'properties.coordinateMode') !== 'manual';
    },
    integerRule() {
      return [v => !!v && !isNaN(v) || this.$i18n_t('DigitalTwin.DigitalTwin.states.randomMustBeNumber')];
    },
    numberRule() {
      return [v => !!v && /^([0-9]+)\.?([0-9]*)$/.exec(v) !== null || parseFloat(v) === 0 || this.$i18n_t('DigitalTwin.DigitalTwin.states.randomMustBeNumber')];
    },
    thresholdAlertRule() {
      return this.numberRule.concat([v => parseFloat(v) >= 1 || this.$i18n_t('NiotaClassic.GWMonitoring.form.alertMin1Hour')]);
    }
  },
  created() {
    this.formItem = cloneDeep(this.editedItem);
    if (!this.formItem.properties) {
      this.formItem.properties = {};
    }
    if (!this.formItem.properties.threshold) {
      this.formItem.properties.threshold = {
        green: 5,
        yellow: 12
      };
    }
  },
  mounted() {
    this.initAddrObject = {
      address: get(this.formItem, 'properties.formatted_address') || null,
      coordinates: get(this.formItem, 'coordinates.coordinates') || [null, null]
    };
  },
  methods: {
    selectedOriginator(originator) {
      if (!get(this.formItem, 'properties')) {
        set(this.formItem, 'properties', {});
      }
      this.formItem.properties.originator = {
        id: originator.id
      };
      this.formItem.properties.datasource = {
        id: get(originator, 'datasource.id')
      };
      this.originatorDialog = false;
    },
    formatLastPacketTime(duration) {
      const durationHours = Math.floor(duration);
      const durationMinutes = Math.round(duration * 60) - durationHours * 60;
      const hoursString = this.$i18n_tc('NiotaClassic.GWMonitoring.hours', durationHours, {
        n: durationHours
      });
      const minutesString = this.$i18n_tc('NiotaClassic.GWMonitoring.minutes', durationMinutes, {
        n: durationMinutes
      });
      if (durationMinutes > 0 && durationHours < 24) {
        return `${hoursString} ${minutesString}`;
      }
      return hoursString;
    },
    createOrUpdateGW() {
      if (this.formItem.id) {
        if (!this.formItem.coordinates) {
          this.formItem.coordinates = {};
        }
        this.updateRequest();
      } else {
        this.createRequest();
      }
    },
    attachmentsUpdated(data) {
      this.formItem.properties.attachments = data;
    },
    updateRequest() {
      return ApiService.gwMgmtUpdate(this.formItem).then(response => {
        this.$snack(this.$i18n_t('NiotaClassic.GWMonitoring.snacks.updateSuccess'), 'success');
        this.$emit('updated', response);
        this.$emit('close');
      }).catch(error => {
        if (error.code === 'ECONNABORTED' || get(error, 'response.status') === 502) {
          this.$snack(this.$i18n_t('DigitalTwin.DigitalTwin.copy.timeoutSnack'), 'error');
          return;
        }
        const errorTranslateKey = `Error.${get(error, 'response.data.message')}`;
        if (error.response && this.$i18n_t(errorTranslateKey) !== errorTranslateKey) {
          this.$snack(this.$i18n_t(errorTranslateKey), 'error');
        } else {
          this.$snack(this.$i18n_t('NiotaClassic.GWMonitoring.snacks.updateFailed'), 'error');
        }
        console.error(error);
      });
    },
    createRequest() {
      ApiService.gwMgmtCreate(this.formItem).then(() => {
        this.$emit('created');
        this.$emit('close');
        this.$snack(this.$i18n_t('NiotaClassic.GWMonitoring.snacks.createSuccess'), 'success');
      }).catch(error => {
        if (error.code === 'ECONNABORTED' || get(error, 'response.status') === 502) {
          this.$snack(this.$i18n_t('DigitalTwin.DigitalTwin.copy.timeoutSnack'), 'error');
          return;
        }
        const errorTranslateKey = `Error.${get(error, 'response.data.message')}`;
        if (error.response && this.$i18n_t(errorTranslateKey) !== errorTranslateKey) {
          this.$snack(this.$i18n_t(errorTranslateKey), 'error');
        } else {
          this.$snack(this.$i18n_t('NiotaClassic.GWMonitoring.snacks.createFailed'), 'error');
        }
        console.error(error);
      });
    },
    filterAccounts(item, queryText) {
      return item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    setAddressObject() {
      this.addressObject = {
        address: get(this.formItem, 'properties.formatted_address') || null,
        coordinates: get(this.formItem, 'coordinates.coordinates') || [null, null]
      };
    },
    addressSelected(addressData) {
      set(this.formItem, 'properties.formatted_address', addressData.address);
      set(this.formItem, 'coordinates.coordinates', addressData.coordinates);
      this.formItem.properties = {
        ...(this.formItem.properties || {}),
        coordinateMode: addressData.pickedManualCoordinates ? 'manual' : 'auto'
      };
      this.setAddressObject();
    }
  }
};